import PageContainer from '@/components/PageContainer';

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/components/auth';
import { User } from '@/types/database';
import { FC } from 'react';

export interface Props {
  routingMap: Record<User['role'], string>;
}

/**
 * RoutingPage
 */
const RoutingPage: FC<Props> = ({ routingMap }) => {
  const { user, loading } = useAuth();

  const role = user?.role;
  const path = routingMap[role as User['role']] || '/login';

  return loading ? <PageContainer loading /> : <Navigate to={path} />;
};

export default RoutingPage;
